import { Row, Col, InputGroup, Label } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AttendanceDatePickerProps } from "../../types";
import { MouseEvent } from "react";
import { formattedYMDDate } from "../../../../utils/dateUtils";

const AttendanceDatePicker = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onSubmit,
  startLabel = "Start Date",
  endLabel = "End Date",
  submitLabel = "Submit",
  autoApply = false,
}: AttendanceDatePickerProps) => {
  const handleSubmitClick = (e: MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault();
    onSubmit(startDate, endDate);
  };

  return (
    <Row className={autoApply ? "attendance-date-controls align-items-center" : "align-items-center"}>
      {/* Start Date */}
      <Col xs="6" md="2">
        <InputGroup className="flatpicker-calender">
          <Label className="col-form-label">{startLabel}</Label>
          <ReactDatePicker
            className="form-control flatpickr-input"
            selected={new Date(startDate)}
            dateFormat="dd/MM/yyyy"
            maxDate={autoApply ? new Date(endDate) : undefined}
            onChange={(date: Date) => { if (!date) return; onStartDateChange(date); if (autoApply) onSubmit(formattedYMDDate(date), endDate); }}
          />
        </InputGroup>
      </Col>

      {/* End Date */}
      <Col xs="6" md="2">
        <InputGroup className="flatpicker-calender">
          <Label className="col-form-label">{endLabel}</Label>
          <ReactDatePicker
            className="form-control flatpickr-input"
            selected={new Date(endDate)}
            dateFormat="dd/MM/yyyy"
            minDate={autoApply ? new Date(startDate) : undefined}
            onChange={(date: Date) => { if (!date) return; onEndDateChange(date); if (autoApply) onSubmit(startDate, formattedYMDDate(date)); }}
          />
        </InputGroup>
      </Col>

      {/* Submit Button */}
      {!autoApply && <Col md="2" className="mt-md-2">
        <Btn
          type="submit"
          className="mt-3 mt-md-4 f-12"
          color="primary"
          onClick={handleSubmitClick}
        >
          {submitLabel}
        </Btn>
      </Col>}
    </Row>
  );
};

export default AttendanceDatePicker;
